import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { Button, CardActions, CardContent, Grid, Snackbar, TextField, Typography } from '@material-ui/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { SwxTheme } from 'swx-atomic-component-lib'

import _ from 'lodash'
import SecondaryViewItemComponent from '../common/SecondaryViewItem.component'

import {
  addEnterprise,
  addEnterpriseDomain, claimEnterpriseUsers,
  loadEnterprise,
  updateEnterprise
} from '../../actions/enterprises'
import i18n from '../../i18n'

const styles = theme => ({
  actions: {
    justifyContent: 'flex-end'
  },
  button: {
    textTransform: 'uppercase'
  },
  inlineButton: {
    textTransform: 'uppercase',
    borderRadius: 0,
    width: 154,
    minWidth: 0,
    background: '#2ad18b',
    height: 41,
    marginBottom: 3,
    '&:hover': {
      background: '#3ae19b'
    }
  },
  inlineTextField: {
    width: 'calc(100% - 154px)'
  },
  paragraph: {
    marginTop: 16
  },
  domainTable: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: SwxTheme.palette.white,
    padding: 4,
    marginTop: 16
  },
  domainRow: {
    paddingTop: 6,
    paddingBottom: 6,
    height: 32
  },
  domainCopyButton: {
    color: SwxTheme.palette.primary,
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    paddingRight: 8,
    cursor: 'pointer'
  }
})

class EnterpriseManagerDomains extends Component {
  state = {
    enterprise: { newName: '', newDomainName: '' },
    refreshTimer: null
  }

  constructor (props) {
    super(props)
    this.classes = props.classes
  }

  componentDidMount = () => {
    if (this.props.self.user.Enterprise) {
      this.props.loadEnterprise(this.props.self.user.Enterprise.id)
        .then(() => {
          const timer = setInterval(this.refreshEnterpriseDomains, 15 * 1000)
          this.setState({ timer })
        })
    }
  }

  componentWillUnmount = () => {
    if (this.state.timer) {
      clearInterval(this.state.timer)
    }
  }

  refreshEnterpriseDomains = () => {
    if (this.props.self.user.Enterprise) {
      this.props.loadEnterprise(this.props.self.user.Enterprise.id)
    }
  }

  onSaveEnterpriseNameClicked = (event) => {
    event.preventDefault()
    if (this.props.enterprise) {
      this.props.updateEnterprise(this.props.enterprise.id, { name: this.state.enterprise.newName })
    } else {
      this.props.addEnterprise({ name: this.state.enterprise.newName })
    }
  }

  onAddEnterpriseDomainClicked = (event) => {
    event.preventDefault()
    this.props.addEnterpriseDomain(this.props.enterprise.id, { name: this.state.enterprise.newDomainName })
  }

  handleOnInputChange = (event) => {
    const state = { ...this.state }
    const { target } = event
    _.set(state, target.name, target.value)
    this.setState(state)
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.enterprise) {
      const enterprise = { ...prevState.enterprise, ...nextProps.enterprise }
      return { enterprise }
    } else {
      return null
    }
  }

  onClaimUsers = (event, domainId) => {
    event.preventDefault()
    if (this.props.enterprise) {
      this.props.claimEnterpriseUsers(this.props.self.user.Enterprise.id, domainId)
    }
  }

  render () {
    const { classes } = this.props
    return (
      <Grid container direction='column'>
        <Grid item>
          <>
            <SecondaryViewItemComponent
              name={i18n.enterprise.domains.nameControl.title}
              description={i18n.enterprise.domains.nameControl.desc}
            >
              <>
                <CardContent>
                  <TextField
                    inputProps={{ }}
                    id='enterpriseName'
                    name='enterprise.newName'
                    value={this.state.enterprise.newName || this.state.enterprise.name}
                    onChange={this.handleOnInputChange}
                    type='text'
                    label={i18n.enterprise.domains.nameControl.inputLabel}
                    margin='normal'
                    fullWidth
                    required
                  />
                </CardContent>
                <CardActions>
                  <Button
                    className={classes.button}
                    variant='contained'
                    color='primary'
                    disabled={this.state.enterprise.newName === ''}
                    onClick={(e) => { this.onSaveEnterpriseNameClicked(e) }}
                  >
                    {i18n.common.button.save}
                  </Button>
                </CardActions>
              </>
            </SecondaryViewItemComponent>
            <SecondaryViewItemComponent
              name={i18n.enterprise.domains.addControl.title}
              description={i18n.enterprise.domains.addControl.desc}
              disabled={!this.props.enterprise || !this.props.enterprise.EnterpriseDomains}
            >
              <>
                <CardContent>
                  <TextField
                    className={classes.inlineTextField}
                    inputProps={{ }}
                    id='domainName'
                    name='enterprise.newDomainName'
                    onChange={this.handleOnInputChange}
                    type='text'
                    label={i18n.enterprise.domains.addControl.inputLabel}
                    placeholder='e.g. smarterwx.com'
                    margin='normal'
                    required
                  />
                  <Button
                    className={classes.inlineButton}
                    variant='contained'
                    color='primary'
                    onClick={(e) => { this.onAddEnterpriseDomainClicked(e) }}
                  >
                    {i18n.common.button.add}
                  </Button>
                  {
                    this.props.enterprise && this.props.enterprise.EnterpriseDomains && this.props.enterprise.EnterpriseDomains.length > 0 &&
                      <>
                        <Grid container direction='column'>
                          {this.props.enterprise.EnterpriseDomains.map((domain, index) => {
                            return (
                              <Grid item key={index} className={classes.domainTable}>
                                <Grid container direction='column'>
                                  <Grid item>
                                    <Grid container direction='row' className={classes.domainRow}>
                                      <Grid item xs={2}><Typography variant='body2'>{i18n.enterprise.domains.addControl.table.domain}</Typography></Grid>
                                      <Grid item xs={10}><Typography variant='body2'>{domain.name}</Typography></Grid>
                                    </Grid>
                                    <Grid container direction='row' className={classes.domainRow}>
                                      <Grid item xs={2}>
                                        <Typography variant='body2'>{i18n.enterprise.domains.addControl.table.txtKey}</Typography>
                                      </Grid>
                                      <Grid item xs={10}>
                                        <Grid container justify='space-between'>
                                          <Grid item>
                                            <Typography variant='body2' style={{ whiteSpace: 'nowrap' }}>smarterwx-verification={domain.txt_code}</Typography>
                                          </Grid>
                                          <Grid item>
                                            <CopyToClipboard text={`smarterwx-verification=${domain.txt_code}`}>
                                              <span className={classes.domainCopyButton}>{i18n.common.button.copy}</span>
                                            </CopyToClipboard>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid container direction='row' className={classes.domainRow}>
                                      <Grid item xs={2}><Typography variant='body2'>{i18n.enterprise.domains.addControl.table.status.label}</Typography></Grid>
                                      <Grid item xs={10}><Typography variant='body2'>{domain.is_verified ? i18n.enterprise.domains.addControl.table.status.verified : domain.is_verification_failed ? i18n.enterprise.domains.addControl.table.status.failed : i18n.enterprise.domains.addControl.table.status.verifying}</Typography></Grid>
                                    </Grid>
                                    {
                                    domain.is_verified &&
                                      <Grid container direction='row' className={classes.domainRow}>
                                        <Grid item xs={12}>
                                          <Button
                                            className={classes.inlineButton}
                                            variant='contained'
                                            color='primary'
                                            onClick={(e) => { this.onClaimUsers(e, domain.id) }}
                                          >
                                            {i18n.enterprise.domains.addControl.table.claimButton}
                                          </Button>
                                        </Grid>
                                      </Grid>
                                  }
                                  </Grid>
                                </Grid>
                              </Grid>
                            )
                          })}
                          {
                            <Snackbar
                              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                              open={this.props.notification && this.props.notification.showNotification}
                              autoHideDuration={3000}
                              onClose={this.handleOnSnackbarClose}
                              ContentProps={{
                                'aria-describedby': 'message-id'
                              }}
                              message={<span id='message-id'>{this.props.notification && this.props.notification.text}</span>}
                            />
                        }
                        </Grid>
                        {/* <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.domainsTableCell}>Domain</TableCell>
                            <TableCell className={classes.domainsTableCell}>Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.props.enterprise.EnterpriseDomains.map((domain, index) => {
                            return (
                              <React.Fragment>
                                <TableRow key={index}>
                                  <TableCell className={classes.domainsTableCell}>{domain.name}</TableCell>
                                  <TableCell className={classes.domainsTableCell}>{
                                    domain.is_verified ? 'Verified' : domain.is_verification_failed ? 'Failed' : 'Verifying'
                                  }</TableCell>
                                </TableRow>
                                <TableRow key={index}>
                                  <TableCell
                                    style={ { textAlign: 'left' } }
                                    className={classes.domainsTableCell}
                                  >
                                    smarterwx-verification={domain.txt_code}
                                  </TableCell>
                                  <TableCell>
                                  <CopyToClipboard text={`smarterwx-verification=${domain.txt_code}`}>
                                    <IconButton aria-label='Copy to clipboard'>
                                      <ContentCopyIcon />
                                    </IconButton>
                                  </CopyToClipboard>
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            )
                          })}
                        </TableBody>
                      </Table> */}
                        <Typography variant='body2' className={classes.paragraph}>
                          {i18n.formatString(i18n.enterprise.domains.addControl.info1, <i>smarterwx-verification=[key]</i>)}
                        </Typography>
                        <Typography variant='body2' className={classes.paragraph}>
                          {i18n.enterprise.domains.addControl.info2}
                        </Typography>
                      </>
                  }
                </CardContent>
              </>
            </SecondaryViewItemComponent>
          </>
        </Grid>
      </Grid>
    )
  }
}

EnterpriseManagerDomains.propTypes = {
}

const mapStateToProps = state => {
  return {
    enterprise: state.enterprise,
    self: state.self,
    notification: state.notification
  }
}

const EnterpriseManagerDomainsComponent = withStyles(styles)(EnterpriseManagerDomains)

export default connect(mapStateToProps, {
  addEnterprise,
  addEnterpriseDomain,
  loadEnterprise,
  updateEnterprise,
  claimEnterpriseUsers
})(EnterpriseManagerDomainsComponent)
